import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";

const UnitContext = createContext(null);

export function UnitProvider({ children }) {
  const { user, apiCall } = useAuth();
  const [units, setUnits] = useState([]);
  const [selectedUnitId, setSelectedUnitIdState] = useState(
    localStorage.getItem("selected_unit_id") || "all"
  );
  const [loading, setLoading] = useState(false);

  const reload = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    try {
      const res = await apiCall("get", "/units");
      const list = res.data || [];
      setUnits(list);
      const validIds = new Set(list.map((u) => u.unit_id));
      const cur = localStorage.getItem("selected_unit_id") || "all";

      // Employee restrito a unidades específicas
      if (user.role !== "master" && (user.unit_ids || []).length > 0) {
        const allowed = (user.unit_ids || []).filter((id) => validIds.has(id));
        if (!cur || cur === "all" || !allowed.includes(cur)) {
          const next = allowed[0] || "all";
          localStorage.setItem("selected_unit_id", next);
          setSelectedUnitIdState(next);
        }
      } else if (cur !== "all" && !validIds.has(cur)) {
        // Master ou employee sem unit_ids: unit selecionada foi excluída → reset
        localStorage.setItem("selected_unit_id", "all");
        setSelectedUnitIdState("all");
      }
    } catch {
      // Em caso de erro, NÃO travar — apenas garante fallback seguro
      const cur = localStorage.getItem("selected_unit_id");
      if (cur && cur !== "all") {
        localStorage.setItem("selected_unit_id", "all");
        setSelectedUnitIdState("all");
      }
    } finally {
      setLoading(false);
    }
  }, [user, apiCall]);

  useEffect(() => {
    reload();
  }, [reload]);

  const setSelectedUnitId = useCallback((id) => {
    const value = id || "all";
    localStorage.setItem("selected_unit_id", value);
    setSelectedUnitIdState(value);
    // Recarrega a página para todas as queries de dados refletirem o novo escopo
    setTimeout(() => window.location.reload(), 50);
  }, []);

  return (
    <UnitContext.Provider
      value={{ units, selectedUnitId, setSelectedUnitId, reload, loading }}
    >
      {children}
    </UnitContext.Provider>
  );
}

export const useUnits = () => {
  const ctx = useContext(UnitContext);
  if (!ctx) return { units: [], selectedUnitId: "all", setSelectedUnitId: () => {}, reload: () => {}, loading: false };
  return ctx;
};
